import React, { useState } from 'react';
import { Button } from '../common/Button';
import { AffiliateProfile } from '../../types/affiliate';
import { getStripeOnboardingLink } from '../../services/firebase/affiliateProfile';

interface AffiliatePayoutsProps {
  affiliate: AffiliateProfile;
}

export const AffiliatePayouts: React.FC<AffiliatePayoutsProps> = ({ affiliate }) => {
  const [loading, setLoading] = useState(false);

  const handleConnectStripe = async () => {
    setLoading(true);
    try {
      const returnUrl = `${window.location.origin}/affiliate-dashboard`;
      const refreshUrl = `${window.location.origin}/affiliate-dashboard`;
      const url = await getStripeOnboardingLink(returnUrl, refreshUrl);
      window.location.href = url;
    } catch (error) {
      console.error('Failed to connect Stripe:', error);
      alert('Failed to initiate Stripe connection. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="bg-white p-6 rounded-lg shadow-sm border border-neutral-200">
      <h3 className="text-lg font-semibold text-neutral-900 mb-4">Payout Settings</h3>
      
      <div className="mb-6">
        <h4 className="text-sm font-medium text-neutral-700 mb-2">Payment Method</h4>
        {affiliate.stripeAccountId ? (
          <div className="flex items-center justify-between bg-green-50 p-4 rounded-md border border-green-100">
            <div className="flex items-center">
              <div className="bg-white p-1 rounded border border-neutral-200 mr-3">
                {/* Stripe Logo Placeholder */}
                <span className="font-bold text-indigo-600">Stripe</span>
              </div>
              <div>
                <p className="text-sm font-medium text-green-800">Connected</p>
                <p className="text-xs text-green-600">Account ID: {affiliate.stripeAccountId}</p>
              </div>
            </div>
            <Button variant="outline" size="sm">
              Manage Account
            </Button>
          </div>
        ) : (
          <div className="bg-neutral-50 p-4 rounded-md border border-neutral-200">
            <p className="text-sm text-neutral-600 mb-3">
              Connect your Stripe account to receive automatic payouts.
            </p>
            <Button 
              onClick={handleConnectStripe} 
              loading={loading}
              className="w-full sm:w-auto bg-[#635BFF] hover:bg-[#5851E1] text-white border-transparent"
            >
              Connect with Stripe
            </Button>
          </div>
        )}
      </div>

      <div>
        <h4 className="text-sm font-medium text-neutral-700 mb-2">Payout History</h4>
        <div className="overflow-hidden shadow ring-1 ring-black ring-opacity-5 sm:rounded-lg">
          <table className="min-w-full divide-y divide-neutral-300">
            <thead className="bg-neutral-50">
              <tr>
                <th scope="col" className="py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-neutral-900 sm:pl-6">Date</th>
                <th scope="col" className="px-3 py-3.5 text-left text-sm font-semibold text-neutral-900">Amount</th>
                <th scope="col" className="px-3 py-3.5 text-left text-sm font-semibold text-neutral-900">Status</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-neutral-200 bg-white">
              {/* Placeholder for empty state */}
              <tr>
                <td colSpan={3} className="py-4 pl-4 pr-3 text-sm text-neutral-500 text-center sm:pl-6">
                  No payouts yet.
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};
